export const UserIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="52" height="58" viewBox="0 0 52 58" fill="none">
      <path
        d="M51.4558 44.4824C45.6864 52.266 36.432 57.311 25.9993 57.311C15.5667 57.311 6.31239 52.266 0.542969 44.4826C5.23703 35.1861 14.8738 28.811 25.9994 28.811C37.1251 28.811 46.7617 35.186 51.4558 44.4824Z"
        fill="white"
      />
      <path
        d="M38.666 12.9777C38.666 19.9733 32.9949 25.6444 25.9993 25.6444C19.0037 25.6444 13.3327 19.9733 13.3327 12.9777C13.3327 5.9821 19.0037 0.311035 25.9993 0.311035C32.9949 0.311035 38.666 5.9821 38.666 12.9777Z"
        fill="white"
      />
    </svg>
  );
};
